/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 14:12:04
 * @LastEditTime: 2021-04-25 10:41:30
 * @LastEditors: wangshengqiang
 * @Description: 可以快速定位到选择的模块上，相当于模块锚点
 */

/* eslint-disable react-hooks/rules-of-hooks */
import classnames from 'classnames';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { Tabs } from 'zarm';
import { isPreviewMode } from '@/utils/tool';
import './index.less';
const {
  Panel
} = Tabs;

const AnchorTabs = props => {
  const {
    attrs
  } = props;
  const {
    dataSource = [],
    maxTitleCount,
    isMultiple,
    maxCount
  } = attrs;
  const flagObj = useRef();
  const timer = useRef();

  if (dataSource.length === 0) {
    return null;
  }

  const [tabValue, setTabValue] = useState(0);

  const scrollChange = e => {
    if (flagObj.current) return;
    let current = {
      top: undefined,
      index: tabValue
    };
    dataSource.forEach(({
      target
    }, index) => {
      if (document.getElementById(target)) {
        const [{
          top,
          height
        }] = document.getElementById(target).getClientRects(); // 找出没有被完全滚进屏幕顶端的  最上方的元素下标

        if (top - 43 > -height) {
          current = current.top === undefined || top < current.top ? {
            top,
            index
          } : current;
        }
      }
    });
    setTabValue(current.index);
  };

  useEffect(() => {
    if (!isPreviewMode()) {
      document.addEventListener('scroll', _.debounce(scrollChange, 60));
    }
  }, []);

  const tabChange = index => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    flagObj.current = true;
    dataSource.forEach((item, tabIndex) => {
      if (tabIndex === index) {
        setTabValue(index);
        const element = document.getElementById(item.target);

        if (!element) {
          return;
        }

        const a = element.getBoundingClientRect().top;
        const b = document.documentElement.getBoundingClientRect().top;
        document.documentElement.scrollTop = a - b - 42;
        document.body.scrollTop = a - b - 42;
      }
    });
    timer.current = setTimeout(() => {
      flagObj.current = false;
    }, 2000);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "anchor-tabs"
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: tabValue,
    lineWidth: 60,
    onChange: tabChange
  }, dataSource.map((item, index) => {
    const cls = classnames({
      'anchor-tabs-title': true,
      active: index === tabValue
    });
    return /*#__PURE__*/React.createElement(Panel, {
      key: index,
      title: /*#__PURE__*/React.createElement("span", {
        className: cls
      }, item.title)
    });
  })));
};

export default AnchorTabs;